import moment from 'moment';
import {
  passengerCount,
  getAncillaryNameInsurance,
  luggageAncillary,
  emptyBag,
  bagNames,
  sortAlphabetically,
  getDtd,
  getFareType,
  getAncillariesSelected,
} from '../../../../utilities/helpers';
import { sendAncillaryEventToCustomerIO } from '../../../../utilities/customer-io-ancillary-events';
import { CARRY_ON_LABELS } from './constants';

export default (products, pnrModel, userProfile, isActiveFlowCorporate, userCorporate) => {
  const pnrInfo = pnrModel;

  const items = [];
  let tripType = 'MC';
  const segments = [];
  let zone = 'NA';
  let fopType = '';
  let fopTtypeItem = 'Cash';
  let updatedItems = '';
  const legCollection = pnrInfo?.legCollection;
  const outboundSegments = legCollection?.[0]?.segmentsCollection;
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection;
  const baggageCheck = ['0IA', '0CD', '0CE', '0CF', '0CG', '0CH', '0CI', '0LX', '0JH', '0LL', '02T', 'XB5', 'XB6', 'XB7', '08K'];
  let stopNumbers = 0;
  if (pnrInfo?.flightItineraryType === 'ONEWAY') {
    tripType = 'OW';
  } else if (pnrInfo?.flightItineraryType === 'ROUNDTRIP') {
    tripType = 'RT';
  }

  if (legCollection?.length > 0) {
    legCollection.forEach((element) => {
      const data = element?.segmentsCollection;
      stopNumbers = data?.length > 1 ? stopNumbers + (data?.length - 1) : stopNumbers;
      data.map((segmentsData) => {
        segments.push(segmentsData);
      });
    });
  }
  const apiDepartureDate = moment(segments?.[0]?.departureDateTime);
  const transactionDate = moment(pnrInfo?.creationDate);
  const apiItem = apiDepartureDate.diff(transactionDate, 'days');
  const dtd = getDtd(segments?.[0]?.departureDateTime);

  const arrivalAirport = outboundSegments?.[outboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const departureAirport = outboundSegments?.[0]?.departureAirport || 'NA';
  const marketOd = `${departureAirport}${arrivalAirport}`;
  let marketNdod = `${arrivalAirport}${departureAirport}` || 'NA';

  if (departureAirport < arrivalAirport) {
    marketNdod = `${departureAirport}${arrivalAirport}` || 'NA';
  }

  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');

  const inboundDepartureDate = (pnrInfo?.flightItineraryType === 'ROUNDTRIP') ? inboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';
  const inboundArrivalDate = (pnrInfo?.flightItineraryType === 'ROUNDTRIP') ? inboundSegments?.[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';

  const mcOutBoundDepartureDate = (legCollection || []).map((legData) => {
    const firstSegment = legData?.segmentsCollection[0] || [];
    const departureDate = firstSegment?.departureDateTime?.format('YYYYMMDD') || 'NA';
    return departureDate;
  }).join('-');

  const mcOutBoundArrivalDate = (legCollection || []).map((legData) => {
    const lastSegment = legData?.segmentsCollection[legData?.segmentsCollection?.length - 1] || [];
    const arrivalDate = lastSegment?.arrivalDateTime?.format('YYYYMMDD') || 'NA';
    return arrivalDate;
  }).join('-');

  const marketCarrier = (legCollection || []).map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = segmentCollection.map(segment => {
      return `${segment?.marketingCarrier}`;
    }).join('/');
    return segments;
  }).join('-');

  let apItemRange = '';
  switch (true) {
    case (apiItem >= 0 && apiItem <= 2):
      apItemRange = '0 a 2';
      break;
    case (apiItem >= 3 && apiItem <= 6):
      apItemRange = '3 a 6';
      break;
    case (apiItem >= 7 && apiItem <= 13):
      apItemRange = '7 a 13';
      break;
    case (apiItem >= 14 && apiItem <= 20):
      apItemRange = '14 a 20';
      break;
    case (apiItem >= 21 && apiItem <= 27):
      apItemRange = '21 a 27';
      break;
    case (apiItem >= 28 && apiItem <= 49):
      apItemRange = '28 a 49';
      break;
    case (apiItem >= 50 && apiItem <= 89):
      apItemRange = '50 a 89';
      break;
    case (apiItem >= 90 && apiItem <= 119):
      apItemRange = '90 a 119';
      break;
    case (apiItem >= 120 && apiItem <= 149):
      apItemRange = '120 a 149';
      break;
    case (apiItem >= 150):
      apItemRange = '150+';
      break;
    default:
      apItemRange = 'NA';
      break;
  }

  const ancillaries = pnrInfo?.getAllUnPaidAncillaries();
  const seatAncillaries = pnrInfo?.cart?.getAllUnPaidSegmentChoice();

  const upgFilterAncillariesArray = (ancillaries || []).filter(( { ancillary } ) => ancillary?.type == 'UPG');
  const nonUpgFilterAncillariesArray = (ancillaries || []).filter(( { ancillary } ) => ancillary?.type != 'UPG');
  const ancillariesArray = nonUpgFilterAncillariesArray?.map(({ ancillary, legCode }) => ({ redeemedCP: ancillary?.redeemedCP, commercialName: ancillary?.commercialName, type: ancillary?.type, totalCPPoints: ancillary?.currency?.totalCPPoints, total: ancillary?.currency?.total, legCode: legCode }));
  const seatAncillariesArray = seatAncillaries?.map((currentSeat) => ({ redeemedCP: currentSeat?.redeemedCP, commercialName: 'seat', type: currentSeat?.seat?.code, totalCPPoints: currentSeat?.seat?.currency?.totalCPPoints, total: currentSeat?.seat?.currency?.total }));
  const upgAncillariesArray = (upgFilterAncillariesArray || []).map(( { ancillary }) => ({ redeemedCP: ancillary?.redeemedCP, segmentCode: ancillary?.segmentCode, commercialName: 'UPG', type: ancillary?.ancillaryOffer?.ancillary?.type, totalCPPoints: ancillary?.ancillaryOffer?.ancillary?.currency?.totalCPPoints, total: ancillary?.ancillaryOffer?.ancillary?.currency?.total }));
  const allAncillaries = [...ancillariesArray, ...seatAncillariesArray, ...upgAncillariesArray];

  const allCash = allAncillaries?.every(({ redeemedCP }) => redeemedCP === false);
  const allPoints = allAncillaries?.every(({ redeemedCP }) => redeemedCP === true);

  if (allCash) {
    fopType = 'Cash';
  } else if (allPoints) {
    fopType = 'Points';
  } else {
    fopType = 'Cash+points';
  }

  let msItem = 0;
  if (segments?.length > 1) {
    const firstSegment = moment(segments?.[0]?.departureDateTime);
    const lastSegment = moment(segments?.[segments.length - 1]?.arrivalDateTime);
    msItem = tripType !== 'MC' ? lastSegment.diff(firstSegment, 'days') : 0;
  }

  const marketSegments = (legCollection || []).map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = segmentCollection.map(segment => {
      return `${segment?.departureAirport || 'NA'}${segment?.arrivalAirport || 'NA'}`;
    }).join('/');
    return segments;
  }).join('-');

  const bookingClassTest = [];
  const cabinClassTest = [];
  (legCollection || []).forEach((element) => {
    const segmentsInfo = element?.segmentsCollection;
    const bookingClass = [];
    const cabinClass = [];
    (segmentsInfo || []).forEach((segmentsData) => {
      bookingClass.push(segmentsData?.bookingClass || 'NA');
      cabinClass.push(segmentsData?.cabin || 'NA');
    });
    bookingClassTest.push(bookingClass.join('/'));
    cabinClassTest.push(cabinClass.join('/'));
  });
  const bookingClassSegment = bookingClassTest.join('-');
  const cabinClassSegment = cabinClassTest.join('-');

  const travelerCollection = pnrInfo?.cart?.travelerCollection || [];

  const ffNumber = `${userProfile?.ffNumber}`;
  let ffProgram = 'NA';
  travelerCollection.forEach(passenger => {
    if (passenger?.frequentFlyerNumber === ffNumber) {
      ffProgram = passenger?.frequentFlyerProgram;
    }
  });

  const travelerCount = passengerCount(travelerCollection);
  const corpProgram = isActiveFlowCorporate ? 'AM Rewards Business' : 'NA';
  let corpId = 'NA';
  const companySelected = userCorporate?.companySelected;
  (userCorporate?.companies?.companies || []).forEach(company => {
    corpId = company?.companyName === companySelected ? company?.companyLoyaltyNumber : corpId;
  });

  if (pnrInfo?.globalMarketFlight === 'DOMESTIC') {
    zone = 'DOM';
  } else {
    zone = 'INT';
  }
  let values = 0;
  let totalPoints = 0;
  let params = '';

  if (baggageCheck.includes(products?.[0]?.id)) {
    const bags = luggageAncillary(travelerCollection, products);
    products = bags;
    if (products?.length === 0) {
      products = [{
        brand: 'Aeromexico',
        id: 'empty',
        name: 'NA',
        price: 0,
        pricepoints: 0,
      }];
    }
  }

  const [ancillariesSelected, typeOfProductToView] = getAncillariesSelected(travelerCollection, products);
  let mcPrice = 0;
  (products?.products || products).forEach((product) => {
    const productId = product?.id;
    const baggageId = ['0IA', '0CD', '0CZ', '0CE', '0CF', '0CG', '0CH', '0CI', '0LX', '0JH', '0LL', '02T', 'XB5', 'XB6', 'XB7', '08K', 'included', 'empty'];
    const baggage = baggageId?.includes(productId);
    let itemBrand = 'AM';
    let itemCategory = 'Ancillary';
    let itemAffiliation = 'NA';
    let itemCategory2 = 'NA';
    let itemCategory3 = 'NA';
    let itemListName = 'NA';
    let marketSegmentsItem = 'NA';
    let price = 0;
    let pricepoints = 0;
    let mcFlightTime = 0;
    let quantity = 0;

    switch (productId) {
      case 'AMS':
      case 'SEP':
      case 'SDE':
      case 'SXC':
      case 'SXP':
      case 'SVI':
        itemCategory = 'Insurance';
        itemCategory2 = getAncillaryNameInsurance(productId);
        itemAffiliation = 'AM';
        price = product?.price;
        itemBrand = 'CHUBB';
        quantity = ancillariesSelected?.find((insurance) =>  insurance?.type === productId)?.quantity || 0;
        break;
      case 'AMK':
        itemCategory = 'Services';
        itemCategory2 = 'Concierge';
        itemCategory3 = 'NA';
        itemAffiliation = 'AM';
        price = product?.price;
        quantity = travelerCollection?.length;
        break;
      case 'DPM':
      case 'DPI':
        itemCategory = 'Services';
        itemCategory2 = 'Discount Pass';
        itemCategory3 = pnrInfo?.globalMarketFlight === 'DOMESTIC' ? 'MEXICO' : 'INTERNATIONAL';
        itemAffiliation = 'AM';
        price = product?.price;
        quantity = travelerCollection?.length;
        break;
      case '07X':
        itemCategory2 = 'hand luggage';
        const productname = product?.name;
        const split = productname?.split('/');
        itemCategory3 = split?.[0];
        itemAffiliation = 'AM';
        price = product?.price;
        values += price * travelerCollection?.length;
        totalPoints += product?.pricepoints * travelerCollection?.length;
        quantity = ancillariesSelected?.find((ancillary) => ancillary?.type === productId)?.quantity || 0;
        break;
      case '0CZ':
        itemCategory2 = 'Carry on';
        const productName = product?.name.split('/')[0];
        itemCategory3 = productName;
        itemAffiliation = 'AM';
        price = product?.price;
        values += price * travelerCollection?.length;
        totalPoints += product?.pricepoints * travelerCollection?.length;
        quantity = ancillariesSelected?.find((ancillary) => ancillary?.type === productId)?.quantity || 0;
        break;
      case 'UPG':
        itemCategory = 'Upgrade';
        itemCategory2 = segments?.[0]?.fareFamily;
        itemAffiliation = 'AM';
        price = product?.price;
        pricepoints = product?.pricepoints;
        break;
      default:
        break;
    }

    if (baggage) {
      itemCategory2 = 'Luggage';
      const productname = product?.name;
      const split = productname?.split('/');
      const bagName = split?.[0];
      itemCategory3 = bagNames(bagName);
      itemAffiliation = 'AM';
      pricepoints = product?.pricepoints;
      quantity = product?.quantity;
      if (!product?.isPaid) { 
        price = product?.price;
      }
      values += price * quantity;
      totalPoints += product?.pricepoints * quantity;
    }

    itemCategory2 = itemCategory2?.trim();
    itemCategory3 = itemCategory3?.trim();
    (legCollection || []).forEach((legs, legIndex) => {
      const ancillaries = ['Concierge', 'Discount Pass', 'Insurance'];
      const ancillaryIncluded = itemCategory === 'Insurance' ?  ancillaries?.includes(itemCategory) : ancillaries?.includes(itemCategory2);
      itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Services outbound' : legs?.itineraryPartType === 'OUTBOUND' ? 'Services outbound' : 'Services inbound';
      if (ancillaryIncluded && (legs?.itineraryPartType === 'OUTBOUND' || legIndex === 0)) {
        (legs?.segmentsCollection || []).forEach((passenger, index) => {
          if (index > 0) return;
          const departureDateTime = moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss');
          const departureTime = moment.utc(passenger?.flightDurationInMinutes * 60000).format('HH:mm');
          const opCarrier = passenger?.operatingCarrier;
          const brandedFare = getFareType(passenger);
          itemListName = (tripType === 'OW' || tripType === 'MC') && itemCategory === 'Insurance' ? 'Insurance outbound' : 
            tripType === 'RT' && itemCategory === 'Insurance' ? 'Insurance outbound and insurance inbound' :
              tripType === 'RT' && itemCategory !== 'Insurance' ? 'Services outbound and services inbound' :
                itemListName;
          params = {
            'item_name': marketOd || 'NA',
            'coupon': 'NA',
            'discount': 0,
            'item_brand': itemBrand,
            'item_category': itemCategory,
            'item_category2': itemCategory2,
            'item_category3': itemCategory3,
            'item_list_name': itemListName,
            'item_affiliation': itemAffiliation,
            'price': price,
            'quantity': quantity,
            'index': index,
            'market_ndod_item': marketNdod || 'NA',
            'market_od_item': marketOd || 'NA',
            'market_segment_item': marketSegments,
            'zone_item': passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT' || 'NA',
            'region_item': passenger?.regionKeyFromLeg || 'NA',
            'flight_time_dep': departureDateTime || 'NA',
            'flight_time': departureTime || 'NA',
            'branded_fare': brandedFare,
            'outbound_departure_date_item': outboundDepartureDate || 'NA',
            'inbound_departure_date_item': inboundDepartureDate,
            'fop_type_item': 'Cash',
            'price_points': pricepoints || 0,
            'airport_tax': pnrInfo?.cart?.total?.taxDetails?.TUA || 0,
            'aircraft_type': passenger?.aircraftType || 'NA',
            'aircraft_subfleet': `${opCarrier}${passenger?.aircraftType}` || 'NA',
            'ap_item': apItemRange,
            'ms_item': msItem,
            'cabin_item': passenger?.cabin || 'NA',
            'op_carrier': opCarrier || 'NA',
            'class_item': passenger?.bookingClass || 'NA',
          };
          items.push(params);
        });
      } else if (!ancillaryIncluded) {
        const connectedFlights = legs?.legType === 'CONNECTING' && baggage ? [legs?.segmentsCollection?.[0]] : legs?.segmentsCollection;
        (connectedFlights).forEach((passenger, index) => {
          let aircraftType = 'NA';
          let aircraftSubfleet = 'NA';
          let cabinItem = 'NA';
          let classItem = 'NA';
          let inboundDepartureDateItem = 'NA';
          let outboundDepartureDateItem = 'NA';
          const departureDateTime = moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss');
          const departureTime = moment.utc(passenger?.flightDurationInMinutes * 60000).format('HH:mm');
          let marketOdItem = `${passenger?.departureAirport}${passenger?.arrivalAirport}`;
          let marketNdodItem = sortAlphabetically(passenger?.arrivalAirport, passenger?.departureAirport) || 'NA';
          const opCarrier = passenger?.operatingCarrier;
          const segment = passenger?.departureAirport + '-' + passenger?.arrivalAirport;
          const segmentRoute = passenger?.departureAirport + '_' + passenger?.arrivalAirport;
          const obj = ['hand luggage'];
          const segments = legs?.legType === 'CONNECTING' ? legs?.segmentsCollection?.[0]?.departureAirport : 'NA';
          const connectingFlights = legs?.segmentsCollection;

          if (productId === 'UPG' && product?.route === segment) {
            obj.push('Upgrade');
            quantity = ancillariesSelected?.find((upgsSelected) => upgsSelected?.segmentCode === passenger.segmentCode)?.quantity || 0;
            itemListName = tripType ? (tripType === 'OW' || tripType === 'MC') ? 'Upgrade outbound' : legs?.itineraryPartType === 'OUTBOUND' ? 'Upgrade outbound' : 'Upgrade inbound' : 'NA';
          } else if (baggage && (product?.route?.includes(passenger?.departureAirport) || product?.route?.includes(segmentRoute) || product?.route?.includes(segments) )) {
            obj.push('Luggage');
            fopTtypeItem = product?.id === 'included' ? 'Cash' : product?.pricepoints === 0 ? 'Cash' : 'Points';
            itemListName = tripType ? (tripType === 'OW' || tripType === 'MC') ? 'ancillaries outbound' : legs?.itineraryPartType === 'OUTBOUND' ? 'ancillaries outbound' : 'ancillaries inbound' : 'NA';
          }
          if (baggage && legs.legType === 'CONNECTING') {
            mcPrice = 0;
            marketOdItem = connectingFlights?.[0]?.departureAirport + connectingFlights?.[connectingFlights?.length - 1]?.arrivalAirport;
            marketNdodItem = sortAlphabetically(connectingFlights?.[connectingFlights?.length - 1]?.arrivalAirport, connectingFlights?.[0]?.departureAirport) || 'NA';
            marketSegmentsItem = (connectingFlights || []).map((segment) => {
              return `${segment?.departureAirport || 'NA'}${segment?.arrivalAirport || 'NA'}`;
            }).join('/');
            (connectingFlights || []).forEach((segment) => {
              mcPrice +=  segment?.layoverToNextSegmentsInMinutes + segment?.flightDurationInMinutes;
            });
            mcFlightTime = moment?.utc(mcPrice * 60000).format('HH:mm');
            outboundDepartureDateItem = legs?.itineraryPartType === 'OUTBOUND' || tripType === 'MC' ? connectingFlights?.[0]?.departureDateTime?.format('YYYYMMDD') + '/' + connectingFlights?.[connectingFlights?.length - 1]?.departureDateTime?.format('YYYYMMDD') : 'NA';
            inboundDepartureDateItem = legs?.itineraryPartType === 'INBOUND' && tripType === 'RT' ? connectingFlights?.[0]?.arrivalDateTime?.format('YYYYMMDD') + '/' + connectingFlights?.[connectingFlights?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';
            aircraftType = connectingFlights?.[0]?.aircraftType + '/' + connectingFlights?.[connectingFlights?.length - 1]?.aircraftType;
            aircraftSubfleet = connectingFlights?.[0]?.operatingCarrier + connectingFlights?.[0]?.aircraftType + '/' + connectingFlights?.[connectingFlights?.length - 1]?.operatingCarrier + connectingFlights?.[connectingFlights?.length - 1]?.aircraftType;
            cabinItem = connectingFlights?.[0]?.cabin + '/' + connectingFlights?.[connectingFlights?.length - 1]?.cabin;
            classItem = connectingFlights?.[0]?.bookingClass + '/' + connectingFlights?.[connectingFlights?.length - 1]?.bookingClass;
          }

          const category = productId === 'UPG' || productId === '0CZ' ? itemCategory : itemCategory2;
          const ancillaryFlag = obj?.includes(category);
          const brandedFare = getFareType(passenger);
          const flightDuration = legs.legType === 'CONNECTING' && baggage ? mcFlightTime : departureTime || 'NA';
          const marketSegmntItem = legs?.legType === 'CONNECTING' && baggage ? marketSegmentsItem : marketOdItem || 'NA';
          const outbounDepartureItem = legs?.legType === 'CONNECTING' && baggage ? outboundDepartureDateItem : outboundDepartureDate || 'NA';
          const inboundDepartureItem = legs?.legType === 'CONNECTING' && baggage  ? inboundDepartureDateItem : inboundDepartureDate || 'NA';
          const airCraft = legs?.legType === 'CONNECTING' && baggage ? aircraftType : passenger?.aircraftType || 'NA';
          const CraftSubfleet =  legs?.legType === 'CONNECTING' && baggage ? aircraftSubfleet : `${opCarrier}${passenger?.aircraftType}` || 'NA';
          const cabinItems = legs?.legType === 'CONNECTING' && baggage ? cabinItem : passenger?.cabin || 'NA';
          const classItems = legs?.legType === 'CONNECTING' && baggage ? classItem : passenger?.bookingClass || 'NA';

          if (ancillaryFlag || productId === '0CZ' || productId === '07X') {
            params = {
              'item_name': marketOdItem || 'NA',
              'coupon': 'NA',
              'discount': 0,
              'item_brand': itemBrand,
              'item_category': itemCategory,
              'item_category2': productId === '0CZ' || productId === '07X' ? CARRY_ON_LABELS.CARRY_ON : itemCategory2,
              'item_category3': productId === '0CZ' ? CARRY_ON_LABELS.CARRY_ON_10KG : productId === '07X' ? CARRY_ON_LABELS.CARRY_ON_PLUS_5KG : itemCategory3,
              'item_list_name': itemListName,
              'item_affiliation': itemAffiliation,
              'price': price,
              'quantity': quantity || 0,
              'index': index,
              'market_ndod_item': marketNdodItem || 'NA',
              'market_od_item': marketOdItem || 'NA',
              'market_segment_item': marketSegmntItem,
              'zone_item': passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT' || 'NA',
              'region_item': passenger?.regionKeyFromLeg || 'NA',
              'flight_time_dep': departureDateTime || 'NA',
              'flight_time': flightDuration,
              'branded_fare': productId === '0CZ' ? 'LIGHT' : brandedFare,
              'outbound_departure_date_item': outbounDepartureItem,
              'inbound_departure_date_item': inboundDepartureItem,
              'fop_type_item': fopTtypeItem,
              'price_points': pricepoints || 0,
              'airport_tax': pnrInfo?.cart?.total?.taxDetails?.TUA || 0,
              'aircraft_type': airCraft,
              'aircraft_subfleet': CraftSubfleet,
              'ap_item': apItemRange,
              'ms_item': msItem,
              'cabin_item': cabinItems,
              'op_carrier': opCarrier || 'NA',
              'class_item': classItems,
            };
            items.push(params);
          }
        });
      }
    });
    if ( product?.id === 'empty') {
      params = emptyBag();
      items.push(params);
      return;
    }
  });

  updatedItems = (items || []).filter((obj, index, item) =>
    index === item.findIndex((value) => (
      value?.price === obj?.price && value?.item_name === obj?.item_name && value?.item_category3 === obj?.item_category3 && value?.flight_time === obj?.flight_time
    ))
  );

  if (!baggageCheck.includes(typeOfProductToView)) {
    values = 0;
    values = ancillariesSelected?.reduce((acc, product) => {
      return !product?.redeemedCP ? acc + (product?.price * product?.quantity) : acc;
    }, 0);
    totalPoints = ancillariesSelected?.reduce((acc, product) => {
      return product?.redeemedCP ? acc + (product?.pricepoints * product?.quantity) : acc;
    }, 0);
  }
  
  if (totalPoints > 0 && values > 0) {
    fopType = 'Cash+Points';
  } else if (totalPoints > 0 && values === 0) {
    fopType = 'Points';
  } else {
    fopType = 'Cash';
  }

  const result = {
    event: 'view_item',
    ecommerce: {
      'currency': products?.currencyCode || pnrInfo?.cart?.total?.currencyCode || 'NA',
      'value': values || 0,
      'funnel_name': 'MYB',
      'sub_funnel_name': 'Ancillary',
      'trip_type': tripType,
      'fop_type': fopType,
      'outbound_departure_date': tripType === 'MC' ? mcOutBoundDepartureDate : outboundDepartureDate || 'NA',
      'inbound_departure_date': inboundDepartureDate,
      'outbound_arrival_date': tripType === 'MC' ? mcOutBoundArrivalDate : outboundArrivalDate || 'NA',
      'inbound_arrival_date': inboundArrivalDate,
      'zone': zone,
      'market_od': marketOd || 'NA',
      'market_ndod': marketNdod || 'NA',
      'market_segment': marketSegments,
      'mkt_carrier': marketCarrier || 'NA',
      'region': legCollection?.[0]?.regionKey || 'NA',
      'value_points': totalPoints || 0,
      'ffn_program': ffProgram,
      'ffn_id': ffNumber === 'undefined' ? 'NA' : ffNumber,
      'corp_program': corpProgram,
      'corp_id': corpId,
      'adults': travelerCount?.adults,
      'childs': travelerCount?.child,
      'infants': travelerCount?.infants,
      'adult_minor': travelerCount?.adultMinors,
      'stops_number': stopNumbers,
      'dtd': dtd,
      'clid_benefits': 'NA',
      'cabin': cabinClassSegment || 'NA',
      'class': bookingClassSegment || 'NA',
      'items': updatedItems,
    },
  };

  try {
    sendAncillaryEventToCustomerIO('upgrades', result, pnrInfo);
  } catch (error) {
    // Silent error
  }

  return result;
};
